/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { useGlobalState } from 'src/core/hooks/useGlobalState';

/**
 * A hook used to initialize the app entities, intents and phraseLists by doing the following.
 * 1) Fetches the current app intents, entities and phrase lists stores.
 * 2) Return them with the loading state of these store houses.
 */
export const useModels = () => {
    const { rootStore, dispatcher } = useGlobalState();
    const currentAppStore = rootStore.currentLuisAppStore;
    const {
        items: entityStores,
        isLoaded: areEntitiesLoaded,
        isLoading: areEntitiesLoading
    } = currentAppStore.currentAppVersionStore.entityStoreHouse;

    const {
        items: intentStores,
        isLoaded: areIntentsLoaded,
        isLoading: areIntentsLoading
    } = currentAppStore.currentAppVersionStore.intentStoreHouse;

    const {
        items: phraseListStores,
        isLoaded: arePhraseListsLoaded,
        isLoading: arePhraseListsLoading
    } = currentAppStore.currentAppVersionStore.phraseListStoreHouse;

    React.useEffect(() => {
        dispatcher.dispatch('loadEntities');
        dispatcher.dispatch('loadIntents');
        dispatcher.dispatch('loadPhraseLists');
    }, []);

    return {
        intentStores,
        entityStores,
        phraseListStores,
        isLoaded: areEntitiesLoaded && areIntentsLoaded && arePhraseListsLoaded,
        isLoading: areEntitiesLoading || areIntentsLoading || arePhraseListsLoading
    };
};
